<template>
<div id="AddUser">
<b-modal id="modal-sm" size="md" title="Role Permission" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
   </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="PopMsgClose"> Close </b-button>
      </div>
</b-modal>
    <div class="form-group row my-1">
    <label for="SearchClinics" class="col-sm-3 col-form-label-xs">Location:</label>
    <div class="col-sm-4">
      <vue-bootstrap-typeahead ref="SearchClinic"  :inputClass="TypeHeadinptClass"  v-model="searchloc"  :data="Locations"  @hit="SelectedClinic = $event"
          :serializer="item => item.text"  textVariant=".text-primary"   placeholder="Search Clinic"  size="sm"  backgroundVariant="bg-light" :maxMatches="20" >
          <template slot="prepend">
          <span class="input-group-text form-control-xs" style="font-size: .7rem;"><i class="fas fa-search fa-sm"></i></span>
          </template>                      
      </vue-bootstrap-typeahead>      
     </div> 
      <div :class="{ 'col-sm-1 my-0': $v.searchloc.$error}"   v-show="$v.searchloc.$error" >
         <div class="row">
        <small class="sml-red" v-if="!$v.searchloc.required">Search Clinic.</small>
        </div>
      </div> 
    </div>
    <div class="form-group row  my-0">
    <div class="col-sm-3 my-0"></div>
    <div class="col-sm-7 mr-0 my-0" v-if="searchloc"><small>Clinic #: {{SelectedClinic.value}}</small></div>
    </div>  
  <form>  
  <div class="form-group row  my-0">
    <label for="UserID" class="col-sm-3 label-small my-0">User ID:</label>
    <div class="col-sm-4 my-0">
      <input id="UserID" v-model="uid" placeholder="User ID" class="form-control form-control-xs my-0 mb-0">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.uid.$error}"   v-show="$v.uid.$error">
       <div class="row">
        <small class="sml-red" v-if="!$v.uid.required">User ID is required.</small>
        </div>
       <div class="row">
         <small class="sml-red" v-if="!$v.uid.minLength">Minimum 7 characters. 
           </small>
        </div>
        <div class="row">
         <small class="sml-red" v-if="!$v.uid.maxLength">Maximum 15 characters. 
           </small>
        </div>      
          <div class="row"> 
              <small class="sml-red" v-if="!$v.uid.UserIDCheck">Must meet the alphamumeric requirements.</small>
         </div>           
    </div>
  </div>
   <div class="form-group row  my-0">
    <div class="col-sm-3 my-0"></div>
    <div class="col-sm-7 mr-0 my-0">
      <small class="sml-red">UID: Minimum 7 and maximum 15 characters are allowed.</small>
    </div>
  </div>    
  <div class="form-group row  my-0">
    <label for="usernm" class="col-sm-3  label-small my-0">User Name:</label>
    <div class="col-sm-4 my-0">
       <input id="usernm" v-model="username" placeholder="User Name" class=" my-0 form-control form-control-xs">
    </div>
    <div :class="{ 'col-sm-4 my-0': $v.username.$error}"   v-show="$v.username.$error">
        <div class="row">
         <small class="sml-red" v-if="!$v.username.minLength">Minimum 3 characters. 
           </small>
        </div>
        <div class="row">
         <small class="sml-red" v-if="!$v.username.maxLength">Maximum 50 characters. 
           </small>
        </div>       
    </div>
  </div> 
   <div class="form-group row my-0 mt-1 mb-0">
    <label for="Password" class="col-sm-3 label-small my-0">Password:</label>
    <div class="col-sm-4 my-0 no-gutters ml-0">

        <div class="input-group form-group">
            <div class="input-group-prepend">
                <!-- <span class="input-group-text"><i class="fas fa-key"></i></span> -->
            </div>   
            <input v-model.trim="$v.newPassword.$model"  v-bind:type="[showPassword ? 'text' : 'password']" class="form-control form-control-xs" placeholder="Password">
            <div class="input-group-append form-control-xs">
            <span class="input-group-text form-control-xs" @click="showPassword = !showPassword">
                    <i class="fa" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i>
            </span>
            </div>
         </div> 

      <!-- <input type="password" id="Password" v-model.trim="$v.newPassword.$model" placeholder="Password" class="mb-0 form-control form-control-xs"> -->
    </div>
    <!-- <div class="col-sm-2 my-0 no-gutters pl-0 ml-0"> 
        <i class="fa fa-eye fa-xs"  aria-hidden="true"></i>
        {{newPassword}}
    </div> -->
    <div class="col-sm-4 my-0"  v-show="$v.newPassword.$error" :class="{ 'col-sm-4 mb-0': $v.newPassword.$error}">
          <div class="row">
              <small class="sml-red" v-if="!$v.newPassword.required">Password is required.</small> 
          </div> 
           <div class="row">
              <small class="sml-red" v-if="!$v.newPassword.minLength">Minimum {{$v.newPassword.$params.minLength.min}} characters.</small>
          </div>
          <div class="row"> 
              <small class="sml-red" v-if="!$v.newPassword.PasswordCheck">Must meet the requirements.</small>
         </div>
        <div class="row">
            <small class="sml-red" v-if="!$v.newPassword.UserNameVerify">Password should not contain userid.
             </small>
        </div>
    </div>
  </div>
  <div class="form-group row  my-0 py-0">
    <div class="col-sm-3 my-0 py-0"><span class="col-sm-4 my-0 py-0"></span></div> 
      <p class="col-sm-4 my-0 py-0 sml-red pl-3">PWD: Minimum 12 characters. Passwords must use 3/4 available character types. Lowercase letters, Uppercase letters, Numbers and Symbols.</p>
  </div>
   <div class="form-group row my-0">
    <label for="CoPassword" class="col-sm-3 label-small">Confirm Password:</label>
    <div class="col-sm-4">      
      <input id="CoPassword" type="password" v-model="confirmPassword"  placeholder="Password" class=" my-0 form-control form-control-xs">
    </div>
    <div  :class="{ 'col-sm-4 mb-0': $v.confirmPassword.$error}"   v-show="$v.confirmPassword.$error">
      <div class="row">
        <small class="sml-red" v-if="!$v.confirmPassword.required">Confirm Password is required.</small>
        </div>
       <div class="row">
         <small class="sml-red" v-if="!$v.confirmPassword.sameAs">Must be the same as Password. 
           </small>
        </div> 
    </div>
  </div>
 <div class="form-group row my-0 mt-1">
    <label  class="col-sm-3 label-small">Service Type:</label>
    <div class="col-sm-4">
         <select v-model="selectService" :disabled="DisableService" v-on:change="fillroles($event)"  class="form-control form-control-xs">
            <!-- <option disabled value="" selected="selected">Select Service</option> -->
             <option v-for="option in Services" v-bind:value="option.serviceid" :key="option.serviceid">
              {{ option.service }}
            </option>
          </select>
     </div>
    <div :class="{ 'col-sm-4 mb-0': $v.selectService.$error}"   v-show="$v.selectService.$error"> 
          <div class="row">
         <small class="sml-red" v-if="!$v.selectService.required">Select Service 
           </small>
        </div> 
    </div>
  </div> 

   <div class="form-group row my-0 mt-1">
    <label   class="col-sm-3 label-small">Role:</label>
    <div class="col-sm-4">
       <select v-model="selectRole" class="form-control form-control-xs">
            <!-- <option disabled value="" selected="selected">Select Role</option> -->
             <option v-for="option in Roles" v-bind:value="option.roleid" :key="option.roleid">
              {{ option.role }}
            </option>
            </select>
     </div>
       <div :class="{ 'col-sm-4 mb-0': $v.selectRole.$error}"  v-show="$v.selectRole.$error"> 
          <div class="row">
         <small class="sml-red" v-if="!$v.selectRole.required">Select Role 
           </small>
        </div> 
       </div>
  </div> 

  <div class="form-group row  my-0 mb-0 mt-1">
    <label  class="col-sm-3 label-small mb-0">Start Date:</label>
    <div class="col-sm-4 ">
     
    <div><datepicker typeable  :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }"  v-model="StartDate" :format="DateFormat" :bootstrap-styling="true" :input-class="datapickClass"></datepicker></div>
    </div>
       <div :class="{ 'col-sm-4 mb-0': $v.StartDate.$error}"  v-show="$v.StartDate.$error"> 
          <div class="row mb-0">
         <small class="sml-red" v-if="!$v.StartDate.required">Start Date is required.
           </small>
        </div >
        <div class="row mb-0"><small v-if="!$v.StartDate.minValue" class="sml-red">Start date can't be in the past</small>
        </div>
       </div>
  </div> 
 <div class="form-group row   my-1 mb-0">  
    <label   class="col-sm-3 label-small mb-0">End Date:</label>
    <div class="col-sm-4  my-0 mb-0">
      <datepicker  :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="EndDate" :format="DateFormat" :bootstrap-styling="true" :input-class="datapickClass"></datepicker>
    </div>    
    <div :class="{ 'col-sm-4 mb-0': $v.EndDate.$error}"  v-show="$v.EndDate.$error"> 
          <div class="row mb-0">
         <small class="sml-red" v-if="!$v.EndDate.required">End  Date is required.
           </small>
        </div> 
         <div class="row mb-0"><small v-if="!$v.EndDate.minValue" class="sml-red">End date can't be in the past</small>
        </div>
    </div>
  </div>
  
    
  <div class="form-group row  my-0 py-0">
  <div class="col-sm-3 my-0 py-0"><span class="col-sm-4 my-0 py-0"></span></div> 
    <div class="col-sm-8 my-0 py-0 sml-red pl-3 mb-0">
        <template><RadioToggleButtons  v-model='EndDate' :values='OpenEndedDate' color='#006537' textColor='#000' selectedTextColor='#fff' /><span v-on:click="EndDate=''" style="font-size: 1em;"><i class="fas fa-times ml-2 pointer"></i>  </span> </template>
    </div>  
  </div> 
   <div class="form-group row  my-0 py-0">
    <div class="col-sm-3 my-0 py-0"><span class="col-sm-4 my-0 py-0"></span></div> 
      <p class="col-sm-7 my-0 py-0 sml-red pl-3">Date Format: YYYY/MM/DD</p> 
  </div> 
</form>
<hr>
<div class="row">
    <div class="col-sm-5">
        <button v-on:click="AddUser" type="button" class="btn BtnSave btn-sml"><i class="fas fa-plus"></i> Add User </button>
    </div> 
    <div class="col-sm-5">
        <button v-on:click="Exit" type="button" class="btn BtnClose btn-sml"> <i class="fas fa-times"></i> Close Form  </button>
    </div>
    <div class="col-sm-2">
    </div>
</div> 
  
 </div>
   
</template>

<script>
 
import axios from 'axios'
import Vue from 'vue'; 
import Vuelidate from 'vuelidate'
import { helpers } from 'vuelidate/lib/validators' 
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {required,minLength,sameAs, not, maxLength} from 'vuelidate/lib/validators'
import { notEqual } from 'assert'; 
Vue.use(Vuelidate);
const PasswordCheck = helpers.regex('alphaNum', /(?=.{0,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/)
const UserIDCheck = helpers.regex('alphaNum', /^[a-zA-Z0-9_]+$/)
export default {
   //props:{UserData:Object},
    data: function () {
    return {
       showPassword: false,
   OpenEndedDate: [
        { label: 'Open Ended Date', value: '9999/12/31' }], 
            DisableService :true,
            SelectedClinic:'',
            TypeHeadinptClass:'form-control form-control-xs',
            SearchClinics:'Search Clinics',
            datapickClass:"form-control form-control-xs my-0",
            oldPassword:'',
            newPassword:'',
            confirmPassword:'',
            PWDminLength: 0,
            updateMessage:'',
            showUpdate:true,
            showOldPassword:true,
            uid:'',
            username: '',
            password: '',
            activeColor: 'red',
            fontSize: 30,
            StartDate: '',
            EndDate: '',            
            locnum: '',       
            selectLocation: '',
            searchloc: '',
            Locations:[],
            location: '',
            loclist: '',
            selectService: '',
            Services:[],
            selectRole: '',
            Roles:[], 
            Datepicker: '', 
            adduser: '',
            exit: '',
            DateFormat: '',
            succeeded: false,
            Msg:'',
            showModal:false 
          }
    },
    watch :{
     SelectedClinic:function(val){
        console.log('Clinic change= ' + val.serviceid)
        if(val)
        {
          this.selectService = val.serviceid;
        }
     },
     selectService :function(val){
       console.log('Select Service = '+val)
       if(val)
       {
          this.fillroles();
          this.DisableService =true;
       }
     },
    },
    components: {
        Datepicker,         
    },    
    methods: {
        
        AddUser: function (event) {
           console.log(this.SelectedClinic)
        //console.log(this.$v.$touch)
        this.$v.$touch();
          
          if (!this.$v.$invalid){  
           //  console.log('here')
          var vm = this; 
          //  if(((moment(vm.EndDate)).toISOString() >= moment(new Date("12/31/9998")).startOf('day').toISOString()))
          // {
          //   vm.EndDate = moment(new Date("12/31/9999")).startOf('day');
          // }
          // else{
          //   vm.EndDate = moment(vm.EndDate).startOf('day');
          // }
          // vm.StartDate = moment(vm.StartDate).startOf('day');
          console.log(vm.SelectedClinic)
          var url = "/SaskHealthApi/Security/PostAddUserWithRole/"
          var params = {
                "_": Date.now(),
                "UserName": vm.uid,
                "Password": vm.newPassword,
                "UserFullName": vm.username,
                "ClinicNo": vm.SelectedClinic.value,
                "ServiceID": vm.selectService,
                "RoleID": vm.selectRole,
                "StartDate": vm.StartDate,
                "EndDate": vm.EndDate,
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                 // console.log(response)
                  if(response.status ==200)
                  {
                    if(response.data.succeeded)
                    {
                          vm.succeeded = true;
                          vm.Msg= vm.uid + ": successfully added in to the system.";  
                           vm.showModal=true;  
                    }
                    else if(!response.data.succeeded)
                    {
                          
                          vm.succeeded = false;
                          vm.Msg= response.data.errors;  
                          vm.showModal=true;
                    }
                    else
                    {
                          vm.succeeded = false;
                          vm.Msg="System Error; User is not successfully saved."; 
                           vm.showModal=true; 
                    }
                  }
                  else
                  {
                        vm.succeeded = false;
                        vm.Msg="System Error; User is not successfully saved."; 
                          vm.showModal=true; 
                  }
                   
                })
                .catch(function (error) {
                    if (error.response) {
                     //console.log(error.response.data);
                      //console.log(error.response.status);
                      if(error.response.status ==500)
                      {                   
                          vm.succeeded = false;
                          vm.Msg="System Error; User is not successfully saved."; 
                          vm.showModal=true; 
                      }
                      //console.log(error.response.headers);
                    }
                    console.log(error)
                }); 
          }
        },
        Exit: function (event) {
          this.$root.$emit('bv::hide::modal', 'modalAddEdit', '#btnShow')
        }, 
        fillroles(){
            var vm = this;
            vm.selectRole='';
            vm.Roles =[];
            var params = new URLSearchParams();
             params.append('ServiceID', this.selectService);
             axios.get('SaskHealthApi/Security/GetUserRoles', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             //axios.get('/SaskHealthApi/Codes/GetUserRoles')
                .then(function (response) {
                    //console.log(response.data);
                    //alert(vm.Roles)
                    vm.Roles = response.data
                    //alert(vm.Roles)
                   // console.log(response);
                })
            .catch(function (er) {
                console.log(er)
            })
        }, 

        PopMsgClose(){
          this.showModal=false;
          if(this.succeeded)
          {
            //console.log('at emit')
             this.$emit('finished');
             //this.$root.$emit('bv::hide::modal', 'modalAddEdit', '#btnShow')
              
          } 
        },
        UsernameExist : function()
        {          
          var namefound = this.newPassword.toUpperCase().indexOf(this.uid.toUpperCase()); 
          if(namefound == -1)
          return true;
          else
          return false;          
        },
  },

   //Get Service Type values from Services Table
   mounted: function () {
     this.$nextTick(function () {
       var vm = this;
        axios.get('/SaskHealthApi/Codes/GetServices', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
        .then(function (response) {
                   // console.log(response.data);
                    //alert(vm.Services)
                    vm.Services = response.data
                    //alert(vm.Services)
                   // console.log(response);
                })
            .catch(function (er) {
                console.log(er)
            }) 
            
           axios.get('/SaskHealthApi/Codes/GetClinics', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
                .then(function (response) {
                    //console.log(response.data);
                    vm.Locations = response.data
                   // console.log(response);
                })
            .catch(function (er) {
                console.log(er)
            }) 
      })
    },

  created: function()
  {
    this.DateFormat= this.$store.getters.GetDateFormat;
    this.PWDminLength= this.$store.getters.GetPwdMinLength; 
  }, 
  computed:
  { 
      filteredLocations:function()
      {
       var self=this;
       //console.log('this.Locations')
       ///console.log(this.Locations)
       return this.Locations.filter(function(clinic){return clinic.Locations.toLowerCase().indexOf(self.searchloc.toLowerCase())>=0;});
       
      }      
  },
  validations(){
      return { 
            newPassword:{ 
              required, 
              minLength: minLength(this.PWDminLength),
              PasswordCheck,
              UserNameVerify: value=> this.UsernameExist()
            },
            confirmPassword:{
              required,
              sameAs: sameAs('newPassword')
            },
            uid:{
              required,
               minLength: minLength(7),
                maxLength: maxLength(15),
                UserIDCheck,                
            },
             username:{
              
               minLength: minLength(3),
                maxLength: maxLength(50),
            },
            selectService:{ 
               required,
            },
             selectRole:{ 
               required,
            },
           StartDate:{
                required,
                 minValue: value => (moment(this.StartDate)).toISOString() >= moment(new Date()).startOf('day').toISOString()
            },
            EndDate:{
                required,
                minValue: value => (moment(this.EndDate)).toISOString() >= moment(new Date()).startOf('day').toISOString()
            },
            searchloc:{
              required,
            }
            
      }
  }  
}
</script>

<style scopped>
.calendarCss {
width: 200px; 
padding: 0 !important;
margin: 0 !important;
background: #f3fafe;
}
  .form-control-xs {
    height: calc(1.7em + .350rem + 1px) !important;
    padding: .150rem .25rem !important;
    font-size: .75rem !important;
    line-height: 1.5;
    border-radius: .2rem;
}
.label-small {
  vertical-align: super;
  font-size: small;
}

.modal-header {
    
    padding: .25rem !important;
    align-content: center;
    text-align: center !important;
}
.modal-footer
{
  padding: .75rem !important;
}
.form-group {
  margin-bottom: 0;
}
 /* @media (max-width: 600px) {
    .dropdown-menu{
          max-height:200px;
          overflow-y:auto;
       }
    } */
</style>
